import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-hostelgallery',
  templateUrl: './hostelgallery.component.html',
  styleUrls: ['./hostelgallery.component.scss']
})
export class HostelgalleryComponent implements OnInit {

  constructor(private meta: Meta,
              private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Know About ARNI: Redefining Education and Innovation');
        this.meta.updateTag({
            name: 'description',
            content: `Learn about ARNI's journey of empowering minds with advanced education,
             research, and innovation. Building brighter futures with a passion for excellence.`
        });
    }

}
